export default "__VITE_ASSET__BCAXqXMD__"